import {
  Button,
  Dialog,
  DialogTitle,
  Grid,
  TextField,
  Box,
  Typography,
} from "@mui/material";
import { ReactElement, ReactNode, useEffect, useRef, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { config } from "../../../authConfig";
import { LoadingIndicator } from "../../../Common/UI/components/Loading";
import { CardContainer } from "../../../Common/UI/components/CardContainer";
import useFetchMsal from "../../../Common/UI/hook/useFetchMsal";
import EditIcon from "@mui/icons-material/Edit";
import React from "react";

export interface SimpleDialogProps {
  open: boolean;
  title: string;
  onClose: () => void;
  children: ReactNode;
}

function SimpleDialog(props: SimpleDialogProps) {
  const { onClose, open, children, title } = props;

  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog onClose={handleClose} open={open} className="simple-dialog">
      <DialogTitle>
        <Grid container>
          <Grid item xs={10}>
            <>{title}</>
          </Grid>
          <Grid item xs={2} className="close-icon-container">
            <CloseIcon onClick={onClose} className="close-btn" />
          </Grid>
        </Grid>
      </DialogTitle>
      {children}
    </Dialog>
  );
}

export default function EditApplication({
  app_name,
  app_description,
  refresh,
}: {
  app_name: string;
  app_description: string;
  refresh: () => void;
}): ReactElement {
  const execute = useFetchMsal();

  const [open, setOpen] = useState<boolean>(false);
  const [description, setDescription] = useState<string>(app_description);
  const [name, setName] = useState<string>(app_name);
  const [loading, setLoading] = useState<boolean>(false);

  function handleEdit() {
    const payload = {
      name,
      description,
    };

    setLoading(true);

    const url = config.rootAPIList.updateApplication.replace(
      "{applicationName}",
      app_name
    );

    execute("PUT", `${config.rootAPIUrl}${url}`, payload)
      .then(() => {
        setLoading(false);
        refresh();
      })
      .catch((error: any) => {
        console.log(error);
      })
      .finally(() => {
        handleClose();
      });
  }

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setDescription("");
    setName("");
    setLoading(false);
  };

  return (
    <Box>
      <Grid container>
        <Grid
          item
          xs={12}
          sx={{
            display: "flex",
            justifyContent: "end",
            alignItems: "baseline",
          }}
        >
          <Button
            className={"create-app-btn"}
            onClick={() => {
              handleClickOpen();
            }}
          >
            <>
              <EditIcon /> Edit
            </>
          </Button>
        </Grid>
      </Grid>
      <SimpleDialog
        title={`Edit Application ${name}`}
        key="create-application-key"
        open={open}
        onClose={handleClose}
      >
        <LoadingIndicator show={loading}>
          <CardContainer className="application-dialog">
            <Grid container>
              <Grid item xs={12}>
                <Box
                  component="form"
                  sx={{
                    "& .MuiTextField-root": { m: 1, width: "100%" },
                    height: "120px",
                  }}
                  noValidate
                  autoComplete="off"
                  className="application-description"
                >
                  <div>
                    <TextField
                      id="standard-multiline-static"
                      label="Description"
                      required
                      multiline
                      rows={4}
                      defaultValue={description}
                      variant="standard"
                      className="txt-area"
                      onChange={(ev) => {
                        setDescription(ev.target.value);
                      }}
                    />
                  </div>
                </Box>
              </Grid>
            </Grid>
            <div className="spacer-small"></div>
            <Grid container className={"application-item"}>
              <Grid item xs={12} sx={{ textAlign: "right" }}>
                <Button
                  disabled={
                    loading || name.length === 0 || description.length === 0
                  }
                  onClick={handleEdit}
                >
                  Save
                </Button>
              </Grid>
            </Grid>
          </CardContainer>
        </LoadingIndicator>
      </SimpleDialog>
    </Box>
  );
}
